export default (fileName) => {
  const regEx = /(?:\.([^.]+))?$/;
  let extension = regEx.exec(fileName)[1];
  // Ignore casing
  extension = extension ? extension.toLowerCase() : null;

  if (extension) {
    if (
      extension === 'jpg' ||
      extension === 'jpeg' ||
      extension === 'gif' ||
      extension === 'png' ||
      extension === 'tiff'
    ) {
      return 'fa-picture-o';
    } else if (
      extension === 'pdf'
    ) {
      return 'fa-file-pdf-o';
    } else if (
      extension === 'txt' ||
      extension === 'doc' ||
      extension === 'docx' ||
      extension === 'pages'
    ) {
      return 'fa-file-text-o';
    } else if (
      extension === 'ppt' ||
      extension === 'pptx' ||
      extension === 'keynote'
    ) {
      return 'fa-file-powerpoint-o';
    } else if (
      extension === 'mp4' ||
      extension === 'mp3' ||
      extension === 'avi' ||
      extension === 'webm' ||
      extension === 'mkv'
    ) {
      return 'fa-music';
    } else {
      return 'fa-file-o';
    }
  } else {
    return 'fa-file-o';
  }
};
